const baseUrl = '/consult';
const boxesUrls = {
  baseUrl,
  add: `${baseUrl}/add`,
  addCsv: `${baseUrl}/add-csv`,
  detail: (boxId: number) => `${baseUrl}/${boxId}/detail`,
};

export default boxesUrls;
